import type { AxiosInstance } from 'axios'
import type { IDocumentService } from "./document.type"
import axios from '@/api/axios'
import type { IDocumentData } from "@/models/document"

export class DocumentService implements IDocumentService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/product-documents/'
  }

  async fetchDocuments(): Promise<IDocumentData[]> {
    return this.axios.get(this.endpoint)
      .then(({ data }) => data)
  }
}

// Default export instantiation of the DocumentService
const documentService = new DocumentService(axios)
export default documentService